<script lang="ts" setup>
import { computed } from 'vue';

import defaultImg from '@/assets/images/crystals.svg?bg';

interface CrystalsMediaBoxProps {
    imgBg?: string;
}

const props = defineProps<CrystalsMediaBoxProps>();

const imgSrc = computed(() => props.imgBg || defaultImg);
</script>

<template>
  <div class="crystals-media-box">
    <!-- Контент по центру -->
    <div class="crystals-media-box--content-overlay">
      <slot></slot>
    </div>

    <!-- Основное изображение -->
    <img :src="imgSrc"
         alt="Main Background"
         class="crystals-media-box--img-main"
         decoding="async"
         loading="lazy"
    >

    <!-- Фоновое изображение (blur) -->
    <img :src="imgSrc"
         alt="Blurred Background"
         class="crystals-media-box--img-blur"
         decoding="async"
         loading="lazy"
    >

  </div>
</template>

<style lang="scss" scoped>
.crystals-media-box {
  display: flex;
  position: relative;
  width: 100%;
  min-width: 120px;
  min-height: 120px;

  &--img-main {
    z-index: 1;
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  &--img-blur {
    position: absolute;
    z-index: 0;
    opacity: 0.8;
    inset: 0;
    object-fit: cover;
    filter: blur(80px);
  }

  &--content-overlay {
    display: flex;
    position: absolute;
    z-index: 2;
    align-items: center;
    justify-content: center;
    inset: 0;
  }
}
</style>
